import { pushEvent } from 'src/client/data-layer';
import { LayoutMode } from 'src/components/layout-buttons/types';

export const trackSearchNoResultViewed = (value?: string) => {
  pushEvent('searchNoResultViewed', { value });
};

export const trackSearchCleared = () => {
  pushEvent('searchCleared');
};

export const trackSearchResultCategoriesListed = () => {
  pushEvent('searchResultCategoriesListed');
};

export const trackSearchResultStoresListed = () => {
  pushEvent('searchResultStoresListed');
};

export const trackSearchResultBrandsListed = () => {
  pushEvent('searchResultBrandsListed');
};

export const trackSearchResultExpertArticlesListed = () => {
  pushEvent('searchResultExpertArticlesListed');
};

export const trackSearchResultProductsListed = (
  layout: LayoutMode,
  query: string
) => {
  pushEvent('searchResultProductsListed', { layout, query });
};

export const trackSearchResultProductClicked = (
  id: string | number,
  query: string,
  name?: string
) => {
  pushEvent('searchResultProductClicked', {
    id,
    name,
    query,
  });
};

export const trackSearchResultCategoryClicked = (
  id: string,
  title: string,
  query: string
) => {
  pushEvent('searchResultCategoryClicked', {
    id,
    title,
    query,
  });
};

export const trackSearchResultBrandClicked = (
  id: string,
  title: string,
  query: string
) => {
  pushEvent('searchResultBrandClicked', {
    id: Number(id),
    title,
    query,
  });
};

export const trackSearchResultExpertArticleClicked = (
  id: string,
  title: string,
  type: string,
  url: string,
  query: string
) => {
  pushEvent('searchResultExpertArticleClicked', {
    id: Number(id),
    title,
    type,
    url,
    query,
  });
};

export const trackSearchResultStoreClicked = (
  id: number | string,
  title: string,
  query: string
) => {
  pushEvent('searchResultStoreClicked', {
    id,
    title,
    query,
  });
};

export const trackSearchResultRawOfferClicked = (
  query: string,
  featured?: boolean | null,
  name?: string
) => {
  pushEvent('searchResultRawOfferClicked', {
    featured,
    name,
    query,
  });
};

export const trackSearchDidYouMeanClicked = (
  query: string,
  suggestedQuery: string
) => {
  pushEvent('searchDidYouMeanClicked', {
    query,
    suggestedQuery,
  });
};

export const trackSearchResultSwitchLayout = (
  previousLayout: LayoutMode,
  layout: LayoutMode
) => {
  pushEvent('searchResultSwitchLayout', {
    previousLayout,
    layout,
  });
};
